import type {
    ErrorDetailTaskCheckPayload,
    ErrorDetailTaskCheckResponse,
} from '@/types/apps/error-detail-task-check.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

type ErrorDetailTaskCheckListResponse = ApiResponse<
    PaginatedResult<ErrorDetailTaskCheckResponse>
>;

export class ErrorDetailTaskCheckService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/error-detail-task-check',
        detail: (id: string) => `/api/error-detail-task-check/${id}`,
    };

    public index(
        params?: QueryParams
    ): Promise<ErrorDetailTaskCheckListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<ErrorDetailTaskCheckResponse>> {
        // URL đã bao gồm id
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi<ErrorDetailTaskCheckResponse>(
            url,
            params
        );
    }

    public create(
        params: ErrorDetailTaskCheckPayload
    ): Promise<ApiResponse<ErrorDetailTaskCheckResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), params);
    }

    public update(
        id: string,
        payload: ErrorDetailTaskCheckPayload
    ): Promise<ApiResponse<ErrorDetailTaskCheckResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.putApi(url, payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
